import { ContentArticle } from '../types';
import banner from '../assets/release.jpg';
import { Author } from '../authors/trey';

const body = (<div dangerouslySetInnerHTML={{ __html: `<p>OK, don't tell anyone, but... Playcast is now v1!</p>
<p>Yeah, scratch that - tell everyone.</p>
<p>Here's our change list from the final Beta release. You don't really need to read this, just download it and get started.</p>
<ul>
<li>Updated version number to 1</li>
<li>Over 1800 commits with amazing new changes</li>
<li>Reworked host app user interface for clarity and simplicity</li>
<li>Complete rework of invitation, knock (don't know what that is? ask on Discord), and queueing system</li>
<li>Fix issues with drivers and install (and uninstall, but who needs that?)</li>
<li>Move all authentication to social media or OTP options (now passwordless!)</li>
<li>Update peer-to-peer library with quality control and WebRTC "tweak" capability for improved performance</li>
<li>Add multiple audio tracks for desktop audio and microphone</li>
<li>Add no-video option that uses a static image, but pulled it out at the last second, making Trey sad (coming back soon!)</li>
<li>Add support for inviting friends via email or SMS (Twilio defeated!)</li>
<li>Use multiple cameras so that devices receive streams at appropriate resolutions</li>
<li>Add support for getting to the remote dashboard from the app</li>
<li>Tons of little bug fixes and probably more features I'm not remembering because it's late</li>
</ul>
` }} className="article" />);

export const Release1x0x0: ContentArticle = {
  title: `Release Notes: v1.0.0`,
  slug: `release-1-0-0`,
  published: `2024-09-11`,
  author: Author,
  banner: banner,
  summary: `No way! We made it to v1!`,
  body: body,
};
